export const DROPDOWN_ENTITY_ELEMENT = "entity-dropdown";
